import { Component, OnInit, ViewChild } from "@angular/core";
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { Rest } from "../../../../../../rest/rest_client";
import { AuthenticationService } from "../../../../../../core/services/authentication/authentication.service";
import { I18nService } from "../../../../../../services/i18n/i18n.service";
import { NotificationsService } from "../../../../../../services/notifications-service/notifications.service";
import { RestExt } from "../../../../../../services/rest-client-extension";
import { EntityListComponent } from "../../../../../../components/entity-list/entity-list.component";
import { CecoService } from "app/rest/ceco.service";
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";
import { LeaderFormComponent } from "../leader-form/leader-form.component";
import { LeaderService } from "app/rest/leader.service";

@Component({
    selector: 'app-leader-list',
    templateUrl: './leader-list.component.html',
    styleUrls: ['./leader-list.component.css'],
    providers: [LeaderService, ConfirmationService, UserTimePipe, ExcelService],
    standalone: false
})
export class LeaderListComponent
    extends EntityListComponent<Rest.InvLeader>
    implements OnInit {
    title: string = this.translateService.instant('navbar.clients');

    @ViewChild(LeaderFormComponent, { static: true })
    editForms: LeaderFormComponent;

    disableSave: boolean;

    user: Rest.User;
    EnabledFilter: SelectItem[];

    constructor(
        private leaderService: LeaderService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected excelService: ExcelService,
        protected translateService: TranslateService
    ) {
        super(
            leaderService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
            excelService
        );
        this.leaderService = leaderService;
    }

    ngOnInit() {
        super.ngOnInit();
        this.form = this.editForms;
        this.hasEntityFilters = false;
        /*Permissions */
        this.user = this.authenticationService.user;
        /** */
    }

    protected beforeLoad() {
        if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
            this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
        }
    }

    afterLoad() {
        // this.EnabledFilter = RestExt.getEnabledFilter(
        //     this.filters["enabled"],
        //     this.i18n
        // );
        // this.paginationResult.entities.forEach((cl: any) => {
        //     /*Permissions */
        //     cl._$changeStatus = true; //This is for the validation of entity-list (selectAll function)
        //     cl._$update = true;
        //     /** */
        // });
        // /*Permissions */
        // this.checkSelectAll();
        /** */
    }
    excelColumns = {};
    exportExcel() {
        this.setExcelColumns();
        let fileNameTitle = this.translateService.instant('tableManagement.leaders.leadersManagement');
        super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {
        const name = (entity: any) => entity.user?.surname1 + " " + entity.user.surname2 + ", " + entity.user.name
        const fleetLeader = (entity: any) => entity.fleetLeader ?? ''
        const zoneLeader = (entity: any) => entity.zoneLeader ?? ''
        const serviceLeader = (entity: any) => entity.serviceLeader ?? ''
        const disabled = (entity: any) => !entity.disabled

        this.excelColumns = {
            [this.translateService.instant('general.name')]: { bindField: name },
            [this.translateService.instant('tableManagement.leaders.fleetLeader')]: { bindField: fleetLeader },
            [this.translateService.instant('tableManagement.leaders.zoneLeader')]: { bindField: zoneLeader },
            [this.translateService.instant('tableManagement.leaders.serviceLeader')]: { bindField: serviceLeader },
            [this.translateService.instant('general.active')]: { bindField: disabled },
        }
    }
}
